<ng-container *ngIf="!loading">
  <div class="closeDialog" mat-dialog-close>x</div>
  <div class="parentDiv">
    <div class="title">
      <h5 mat-dialog-title>
       {{dataTitle}}
      </h5>
    </div>
    <div class="severitydiv">
      <form [formGroup]="appForm">
        <h6 class="severityLabel">
          {{ 'component.apps.security-findings.severity' | translate }}: &nbsp;
          &nbsp;
        </h6>
        <ng-select
          class="clsSelect severityDropdown"
          formControlName="severity"
          [clearable]="false"
          (change)="updateSeverity()"
        >
          <ng-option *ngFor="let item of severityDropdown" [value]="item.value">
            <div
              class="clsGrid_dot clsGrid_dotSF_Status"
              [ngClass]="{
                clsDot_cranberry: item.name === 'Critical',
                clsDot_critical: item.name === 'High',
                clsDot_medium: item.name === 'Medium',
                clsDot_minor: item.name === 'Low'
              }"
            ></div>
            {{ item.name }}
          </ng-option>
        </ng-select>
      </form>
    </div>
  </div>
  <ng-container *ngIf="!closeAllFlag">
    <div class="row">
      <h6 class="col-12">
        {{ 'component.apps.security-findings.affected' | translate }}
      </h6>
      <markdown class="col-12 clsFD_Section">
        {{ dataDescriptionIntro }}
      </markdown>
    </div>
    <div class="row">
      <div class="col-12">
        <button
          (click)="closeAllFlag = true"
          class="clsCardButton close-button"
        >
          {{ 'component.apps.security-findings.close-targets' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="closeAllFlag">
    <div class="row">
      <markdown class="col-12 clsFD_Section mt-2 mb-4">
        {{ dataDescriptionIntro }}
      </markdown>
    </div>
  </ng-container>
</ng-container>

<div class="card-body text-center" *ngIf="loading">
  <img
    class="clsImgCenterVertical"
    src="../../../assets/images/icons/reload_big_pink.gif"
  />
</div>

<mat-dialog-content *ngIf="!loading" [ngClass]="{ margin0: closeAllFlag }">
  <div class="row" *ngIf="dataFindingTargets && !closeAllFlag">
    <div [formGroup]="closeIssuesForm" class="col-12">
      <div
        class="clsFindingTargets"
        *ngFor="let item of dataFindingTargets; let i = index"
        [ngClass]="{ 'mb-3': i === dataFindingTargets.length - 1 }"
        formArrayName="issues"
      >
        <div class="row additional-contexts-container">
          <div class="col-12">
            <div class="row">
              <div
                [ngClass]="{ fontWeightToggle: item.seeMore }"
                class="col-12 clsFindingTargetText"
              >
                <markdown>{{ item.text }}</markdown>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  *ngIf="item.additional_contexts && item.seeMore"
                  class="additional-contexts"
                  [class]="seeMore(item)"
                  [formGroupName]="i"
                >
                  <div class="row form-group mb-0">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <label class="clsCardLabel" for="market">{{
                            'component.apps.security-findings.close' | translate
                          }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <ng-select
                            formControlName="close"
                            class="clsSelect"
                            placeholder="Select"
                            [clearable]="false"
                          >
                            <ng-option
                              *ngFor="let item of closeTypeDropdown"
                              [value]="item.value"
                            >
                              {{ item.name }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group mb-0">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <label class="clsCardLabel">
                            {{
                              'component.apps.security-findings.reason'
                                | translate
                            }}</label
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <textarea
                            formControlName="reason"
                            rows="3"
                            type="textarea"
                            class="input-textarea mt-0"
                            [attr.maxlength]="10000"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <button
                        (click)="item.seeMore = false"
                        class="clsCardButtonActions cancel-button"
                      >
                        {{ 'common.cancel' | translate }}
                      </button>
                      <button
                        [disabled]="!issuesFormArray.controls[i].valid"
                        (click)="openEnsureModal(i, item)"
                        [ngClass]="{
                          'create-button': issuesFormArray.controls[i].valid
                        }"
                        class="clsCardButtonActions mr-0 ml-0 clsDisableButton"
                      >
                        {{ 'common.accept' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="item.additional_contexts"
              class="clsCircle see-more"
              [class]="cssClass(item)"
              (click)="checkMoreInfo(item)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="closeAllFlag">
    <div [formGroup]="closeIssuesForm" class="col-12">
      <div
        class="clsFindingTargetsClose"
        *ngFor="let item of dataFindingTargets; let i = index"
        [ngClass]="{ 'mb-3': i === dataFindingTargets.length - 1 }"
        formArrayName="issues"
      >
        <div class="row additional-contexts-container">
          <div class="col-12">
            <div class="row">
              <div
                [ngClass]="{ fontWeightToggle: item.seeMore }"
                class="col-12 clsFindingTargetText"
              >
                <markdown>{{ item.text }}</markdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div [formGroup]="closeAllIssuesForm" class="row" [hidden]="!closeAllFlag">
  <div class="col-12">
    <div class="row form-group mb-0">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <label class="clsCardLabel" for="market">{{
              'component.apps.security-findings.close' | translate
            }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <ng-select
              formControlName="close"
              class="clsSelect"
              placeholder="Select"
              [clearable]="false"
            >
              <ng-option
                *ngFor="let item of closeTypeDropdown"
                [value]="item.value"
              >
                {{ item.name }}
              </ng-option>
            </ng-select>
          </div>

          <div class="col-6 custom-control custom-checkbox">
            <input
              formControlName="permanently"
              type="checkbox"
              class="custom-control-input clsCursorPointer chkios-style"
            />
            <label
              class="custom-control-label clsCardChkLabel clsCursorPointer"
              for="chkios"
              >{{
                'component.apps.security-findings.closed' | translate
              }}</label
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row form-group mb-0">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <label class="clsCardLabel">{{
              'component.apps.security-findings.reason' | translate
            }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <textarea
              formControlName="reason"
              rows="3"
              type="textarea"
              class="input-textarea mt-0"
              [attr.maxlength]="10000"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button
          class="clsCardButtonActions cancel-button"
          (click)="closeAllFlag = false"
        >
          {{ 'common.cancel' | translate }}
        </button>
        <button
          [disabled]="closeAllIssuesForm.invalid"
          (click)="openCloseAllEnsureModal()"
          class="clsCardButtonActions mr-0 ml-0 clsDisableButton"
          [ngClass]="{
            'create-button': closeAllIssuesForm.valid
          }"
        >
          {{ 'common.accept' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
